import { Moment } from 'moment';

export class Article {
    id: string;
    title: string;
    publishDate: Moment;
    articleDate: Moment;
    items: ArticleItem[];
    previewSrc: string;
}

export class ArticleItem {
    id: string;
    content: string;
    type: ArticleType;
}

export enum ArticleType {
    Text = 'text',
    Image = 'image',
    Carousel = 'carousel'
}



// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/core/article.ts